var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.imgHost + (_vm.editmsg.coverimg||_vm.defaultimg),"alt":""}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"play"},[_c('img',{attrs:{"src":"http://routuan2022.oss-cn-hangzhou.aliyuncs.com/routuan/image/zidingyi-play.png","alt":""}})])
}]

export { render, staticRenderFns }